var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
const SvgMenuOutline20 = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: 20,
  height: 20,
  viewBox: "0 0 20 20",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M16 14C16.552 14 17 14.448 17 15C17 15.552 16.552 16 16 16H4C3.448 16 3 15.552 3 15C3 14.448 3.448 14 4 14H16ZM16 9C16.552 9 17 9.448 17 10C17 10.552 16.552 11 16 11H4C3.448 11 3 10.552 3 10C3 9.448 3.448 9 4 9H16ZM16 4C16.552 4 17 4.448 17 5C17 5.552 16.552 6 16 6H4C3.448 6 3 5.552 3 5C3 4.448 3.448 4 4 4H16Z",
  fill: "currentColor"
})));
export { SvgMenuOutline20 as ReactComponent };